<template>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submit)">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">
              {{ form.id ? 'Upload' : 'New Upload' }}
            </h4>
          </div>
          <div class="card-body">
          <file-upload @change="setFiles($event)" :multiple="false"></file-upload>
          <hr>
          
          </div>
          <div class="card-footer text-right">
            <p-button type="info" native-type="submit">Save</p-button>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </template>
  <script>
  import { extend } from "vee-validate";
  import { required } from "vee-validate/dist/rules";
  import { ScannedVoterUpload } from '@/resources/scanned_voter_upload'
import FileUpload from '../../Dashboard/Views/Components/FileUpload.vue';

  extend("required", required);
  
  export default {
  components: { FileUpload },
    props: ['model'],
    data() {
      return {
        form: {
          name: "",
        },
        loading: false,
        file: null
      };
    },
    watch: {
      voter: function () {
        if (this.model) this.form = Object.assign({}, this.model)
      }
    },
    created: function () {
      if (this.model) this.form = Object.assign({}, this.model)
    },
    beforeDestroy() {
      this.form = {
        name: "",
      }
    },
    methods: {
      setFiles(files) {
        this.file = files[0]
      },
      submit() {  
        if (!this.file) {
            this.$notify({
              type: 'danger',
              title: "Error",
              text: 'File is required',
            });
            return
          }
        this.loading = true
        let request = this.form.id ? ScannedVoterUpload.update(this.form) : ScannedVoterUpload.create(this.getFormData())
  
        request
          .then(result => {
            this.$notify({
              type: 'success',
              title: "Success",
              text: 'Uploaded',
            });
            this.$emit('save', true)
          })
          .catch(error => {
        
          }).finally(() => {
            this.loading = false
          })
      },
      getFormData() {
          var formData = new FormData()          
          formData.append('file', this.file.raw)

          return formData
        }
    }
  }
  </script>
  <style></style>
  